// extracted by mini-css-extract-plugin
export default {"AddStudyGroupFromNmm":"AddStudyGroupFromNmm_AddStudyGroupFromNmm__Ianvj"};